<template id="">

    <aside class="md:min-h-screen flex-col items-center shadow hidden md:flex aside--desktop"
           :class="{ active: isActive }"
           v-click-outside="onClickOutside">
        <!-- Side Nav Bar-->
        <ul class="hidden md:flex h-16 flex-grow-0 flex-shrink-0 items-center justify-center w-full logo-container bg-blue-dark">
            <!-- Logo Section -->
            <li>
                <router-link :to="{ name: 'home' }" class="mx-auto" href="#">
                    <img src="../../assets/sharp-logo.png" alt="Sharp - Be Original" class="logo--white"/>
                </router-link>
            </li>

        </ul>

        <ul class="w-full md:mt-20 flex md:block justify-center items-center py-2 py:md-0">
            <li class="px-4 md:mb-6 hidden md:block 2xl:invisible">
                <a @click="isActive = !isActive"
                   class="nav-router-link nav-router-link__collapse w-16 md:w-12 h-12" >
                    <i class="fas fa-chevron-right transition-transform duration-500"></i>
                    <div class="desktop-label">
                        Collapse
                    </div>
                </a>
            </li>


            <li class="px-4 md:mb-6">
                <router-link
                        :to="{ name: 'autologin', query: { war_id: authEquipment ? authEquipment.id : '', serial: authEquipment ? authEquipment.serial : '' } }"
                        active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12">
                    <i class="fas fa-tachometer-fast"></i>
                    <div class="desktop-label inline-block">
                        Dashboard
                    </div>
                </router-link>
            </li>

            <li class="px-4 md:mb-6">
                <router-link
                        :to="{ name: 'bookServiceCall', query: { war_id: authEquipment ? authEquipment.id : '', serial: authEquipment ? authEquipment.serial : '' } }"
                        active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12">
                    <i class="fas fa-wrench"></i>
                    <div class="desktop-label inline-block">
                        Book Service Call
                    </div>
                </router-link>
            </li>

            <li class="px-4 md:mb-6">
                <router-link
                        :to="{ name: 'orderConsumables', query: { war_id: authEquipment ? authEquipment.id : '', serial: authEquipment ? authEquipment.serial : '' } }"
                        active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12">
                    <i class="fas fa-tint"></i>
                    <div class="desktop-label inline-block">
                        Order Consumables
                    </div>
                </router-link>
            </li>

            <li class="px-4 md:mb-6">
                <router-link
                        :to="{ name: 'meterReadings', query: { war_id: authEquipment ? authEquipment.id : '', serial: authEquipment ? authEquipment.serial : '' } }"
                        active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12">
                    <i class="fas fa-print"></i>
                    <div class="desktop-label inline-block">
                        Meter Readings
                    </div>
                </router-link>
            </li>

        </ul>

        <ul class="w-full mt-auto block">
            <li class="px-4 md:mb-6">
                <router-link
                        :to="{ name: 'contact', query: { war_id: authEquipment ? authEquipment.id : '', serial: authEquipment ? authEquipment.serial : '' } }"
                        active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12" >
                    <i class="fas fa-phone"></i>
                    <div class="desktop-label inline-block">
                        Contact Sharp
                    </div>
                </router-link>
            </li>
            <li class="px-4 md:mb-6">
                <router-link
                        :to="{ name: 'signIn' }"
                        active-class="active"
                        class="nav-router-link w-16 md:w-12 h-12">
                    <i class="fas fa-sign-in"></i>
                    <div class="desktop-label inline-block">
                        Sign in
                    </div>
                </router-link>
            </li>
        </ul>
    </aside>
</template>
<script charset="utf-8">
    import Vuex from 'vuex';
    import vClickOutside from 'click-outside-vue3'

    export default {
        name: 'NoUserDesktopNav',
        data() {
            return {
                isActive: false
            }
        },
        computed: {
            ...Vuex.mapGetters('profile', {
                authEquipment: 'authEquipment'
            }),
        },
        directives: {
            clickOutside: vClickOutside.directive
        },
        methods: {
            onClickOutside () {
                this.isActive = false;
            }
        }
    }
</script>

